import { MessageBox } from "element-ui";
import { Message } from "element-ui";
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
  pageSizes: [20, 30, 40, 50, 80, 100, 500],
  pageSize: 20,

  //后台API接口，只需提供后面的路由Path即可
  serverApi(strRouterPath) {
    if (strRouterPath[0] !== "/") strRouterPath = "/" + strRouterPath;
    if (process.env.NODE_ENV === 'development')
      return "http://127.0.0.1:1000" + strRouterPath;
    // return "http://122.112.248.78:8080" + strRouterPath;
    else
      return "http://122.112.248.78:8080" + strRouterPath;
  },

  getDBName() {
    const userInfo = sessionStorage.getItem('userInfo');
    if (userInfo) {
      const user = JSON.parse(userInfo);
      return this.toStrAndTrim(user.dbname);
    }
    else
      return '';
  },

  //询问提示
  async msgAsk(strMessage) {
    try {
      await MessageBox.confirm(strMessage, "询问", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" });
      return true;
    }
    catch (err) {
      return false;
    }
  },

  //普通的弹窗提示
  async msgPopInfo(strMessage) {
    await MessageBox(strMessage, "提示");
  },

  //警告
  async msgPopError(strMessage) {
    await MessageBox.alert(strMessage, "提示", { type: 'error' });
  },

  //项端弹出成功信息提示
  msgOK(strMessage) {
    Message.success({ showClose: true, message: strMessage, type: "success" });
  },

  //项端弹出错误信息提示
  msgError(strMessage) {
    Message.error({ showClose: true, message: strMessage, type: "error" });
  },

  //项端弹出警告信息提示
  msgWarning(strMessage) {
    Message.warning({ showClose: true, message: strMessage, type: "warning" });
  },

  //根据代码显示不同的提示信息，1000成功，1001错误，1002错误，1003，1004警告
  msg(strMessage, code = 1000) {
    const msgCode = code.toString();
    if (msgCode === '1000')
      this.msgOK(strMessage);

    else if (msgCode === '1001' || msgCode === '1002') {
      this.msgError(strMessage);
    }

    else
      this.msgWarning(strMessage);
  },

  //单项信息输入框
  async inputBox(strText, strTitle, contentText = "请输入名称:") {
    try {
      const { value } = await MessageBox.prompt(contentText, strTitle, {
        inputValue: strText,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "输入的内容不能为空",
        closeOnClickModal: false
      });
      return value;
    }
    catch (err) {
      return "";
    }
  },

  //获得默认仓库
  getDefaultCk() {
    try {
      let value = sessionStorage.getItem('default');
      if (value !== 'undefined') {
        value = JSON.parse(value);
        if (value.defaultck !== null && value.defaultck !== undefined)
          return value.defaultck;
        else
          return '';
      }
      else
        return '';
    }
    catch (err) {
      console.log(err);
      return '';
    }
  },

  getDefaultEmp() {
    try {
      let value = sessionStorage.getItem('default');
      if (value !== 'undefined') {
        value = JSON.parse(value);
        if (value.defaultemp !== null && value.defaultemp !== undefined)
          return value.defaultemp;
        else
          return '';
      }
      else return '';
    }
    catch (err) {
      console.log(err);
      return '';
    }
  },

  getDefaultMoneyType() {
    try {
      let value = sessionStorage.getItem('default');
      if (value !== 'undefined') {
        value = JSON.parse(value);
        if (value.defaultmoneytype !== null && value.defaultmoneytype !== undefined)
          return value.defaultmoneytype;
        else
          return '';
      }
      else
        return '';
    }
    catch (err) {
      console.log(err);
      return '';
    }
  },

  getDefaultOType() {
    try {
      let value = sessionStorage.getItem('default');
      if (value !== 'undefined') {
        value = JSON.parse(value);
        if (value.defaultotype !== null && value.defaultotype !== undefined)
          return value.defaultotype;
        else
          return '';
      }
      else
        return '';
    }
    catch (err) {
      console.log(err);
      return '';
    }
  },

  getDefaultItype() {
    try {
      let value = sessionStorage.getItem('default');
      if (value !== 'undefined') {
        value = JSON.parse(value);
        if (value.defaultitype !== null && value.defaultitype !== undefined)
          return value.defaultitype;
        else
          return '';
      }
      else
        return '';
    }
    catch (err) {
      console.log(err);
      return '';
    }
  },

  //合计
  getSummaries(param, sumTextIndex, aryColumnIndexforSum) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === sumTextIndex) {
        sums[index] = '合计';
      }

      if (aryColumnIndexforSum.indexOf(index) !== -1) {
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      }
    });
    return sums;
  },

  //清除页面的状态保持
  clearKeepAlive(that) {
    let vnode = that.$vnode;
    let parentVnode = vnode.parent;

    if (parentVnode && parentVnode.componentInstance.cache) {
      let key = vnode.key == null ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '') : vnode.key;
      let cache = parentVnode.componentInstance.cache;
      let keys = parentVnode.componentInstance.keys;

      if (cache[key]) {
        that.$destroy();
        if (keys.length) {
          let index = keys.indexOf(key)
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
        cache[key] = null;
      }
    }
  },

  ///////////////////////////关闭TAB标签页/////////////////////////////////////////////////////////////////////
  tabClose(self, routeName, ifClearKeepLive = true) {
    if (routeName === 'home') return;

    if (ifClearKeepLive)
      this.clearKeepAlive(self);

    //删除标签，如果只有一个标签，则不会执行删除
    let tabs = self.$store.state.tab.tabList;
    tabs.forEach((tab, index) => {
      if (tab.name === routeName) {
        let nextTab = tabs[index + 1] || tabs[index - 1];
        if (nextTab) {
          self.$store.commit('delTag', tab);
          self.$store.commit('setCurrentMenu', nextTab.name);
          self.$router.push({ name: nextTab.name });
        }
      }
    });
  },

  //对像内的属性全转换为字符串////////////////////////////////////////////////////////////////////////////
  objToString(obj) {
    let newObj = {};
    if (obj) {
      for (let key in obj) {
        newObj[key] = this.toStrAndTrim(obj[key]);
      }
    }
    return newObj;
  },

  //检测是否为数字
  isNum(value) {
    var num = /^(-?\d+)(\.\d+)?$/;
    return num.test(value);
  },

  //检测是否为整型数字，可以是字符串，只要是纯数字即可
  isInt(value) {
    let r = /^0?$|^([1-9][0-9]*)?$/;
    return r.test(value);
  },

  //转换整数
  toInt(value) {
    try {
      const res = parseInt(value);
      if (isNaN(res))
        throw new Error('toInt转换出错');
      else
        return res;
    }
    catch (err) {
      throw new Error(err);
    }
  },

  //检测是否为日期
  isDate(dateStr) {
    if (!dateStr) return false;

    dateStr = dateStr.replace(/\//g, '-');
    var dateReg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    var rValue = dateStr.match(dateReg);
    if (rValue == null) {
      return false;
    }
    rValue[1] = parseInt(rValue[1], 10);
    rValue[2] = parseInt(rValue[2] - 1, 10);
    rValue[3] = parseInt(rValue[3], 10);
    var dateObj = new Date(rValue[1], rValue[2], rValue[3]);
    if (dateObj.getFullYear() != rValue[1] || dateObj.getMonth() != rValue[2] || dateObj.getDate() != rValue[3]) {
      return false;
    }
    return true;
  },

  toFloat(value) {
    try {
      const res = parseFloat(value);
      if (isNaN(res))
        throw new Error('toFloat转换出错');
      else
        return res;
    }
    catch (err) {
      throw new Error(err);
    }
  },

  //转换字符串及去前后空后
  toStrAndTrim(value) {
    if (value === null || value === undefined) {
      throw new Error('toStrAndTrim函数的参数: value未定义')
    }
    else {
      const re = /select%20|update%20|delete%20|truncate%20|join%20|union%20|exec%20|insert%20|drop%20|count|'|"|;|>|<|%/i;
      const res = value.toString()
        .trim();
      const b = re.test(res);
      if (b)
        throw new Error('参数中含有敏感不合法的字符');
      else
        return res;
    }
  },

  //数量小数点位数
  fomatFloat(value, QTY_PRICE_MONEY) {
    let n = 0;
    let sysInfo = sessionStorage.getItem('sysInfo');
    if (sysInfo === 'undefined')
      n = 2;
    else {
      const { qtypoint, pricepoint, moneypoint } = JSON.parse(sysInfo);
      if (QTY_PRICE_MONEY === 'QTY') n = Number(qtypoint);
      else if (QTY_PRICE_MONEY === 'PRICE') n = Number(pricepoint);
      else if (QTY_PRICE_MONEY === 'MONEY') n = Number(moneypoint);
      else return '0';
    }

    if (!this.isNum(value) && !this.isNum(n)) {
      return '0';
    }

    let f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    let s = f.toString();

    if (n === 0) return s;

    let rs = s.indexOf('.');
    if (rs < 0) {
      s += '.';
    }
    for (var i = s.length - s.indexOf('.'); i <= n; i++) {
      s += "0";
    }
    return s;
  },

  //导出EXCEL
  exportExcel(self, refName, excelName) {

    //excelName --设置导出的excel名称
    //report-table --对应的要导出的el-table的ref名称
    try {
      const $e = self.$refs[refName].$el;
      // 如果表格加了fixed属性，则导出的文件会生产两份一样的数据，所以可在这里判断一下
      let $table = $e.querySelector('.el-table__fixed');
      if (!$table) {
        $table = $e;
      }
      // 为了返回单元格原始字符串，设置{ raw: true }
      const wb = XLSX.utils.table_to_book($table, { raw: true });
      const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      FileSaver.saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        `${excelName}.xlsx`,
      );
    }
    catch (e) {
      if (typeof console !== 'undefined') console.error(e);
    }
  },

  //获得成本价
  async getCosPrice(self, ckid, goodsid) {
    if (this.isNum(ckid) && this.isNum(goodsid)) {
      try {
        const value = await self.$axios.get(this.serverApi(`getcosprice/${ckid}/${goodsid}`));
        return value.data.result.price.toString();
      }
      catch (err) {
        console.log(err);
        return '0';
      }
    }
    else {
      return '0';
    }
  },

  //出库使用成本价
  getCkInCosPrice() {
    try {
      const value = JSON.parse(sessionStorage.getItem('sysInfo'));
      if (value) {
        return value.ckincosprice.toString();
      }
      else {
        return '0';
      }
    }
    catch (err) {
      console.log(err);
      return '0';
    }
  },

  getRkInCosPrice() {
    try {
      const value = JSON.parse(sessionStorage.getItem('sysInfo'));
      if (value) {
        return value.rkincosprice.toString();
      }
      else {
        return '0';
      }
    }
    catch (err) {
      console.log(err);
      return '0';
    }
  },

  //是否审核
  getSaveToSh() {
    try {
      const value = JSON.parse(sessionStorage.getItem('sysInfo'));
      if (value) {
        return value.savetosh.toString();
      }
      else {
        return '0';
      }
    }
    catch (err) {
      console.log(err);
      return '0';
    }
  },

  checkUserPower(menuName, btnName) {
    try {
      const userValue = JSON.parse(sessionStorage.getItem('userInfo'));
      const powerValue = JSON.parse(sessionStorage.getItem('roleInfo'));
      if (userValue.username === '管理员' || userValue.username.toLowerCase() === 'admin') {
        return true;
      }

      for (let i = 0; i < powerValue.length; i++) {
        if (powerValue[i].menuname === menuName) {
          if (this.toInt(powerValue[i][btnName]) === 1)
            return true;
          else
            return false;
        }
      }
      return false;
    }
    catch (err) {
      return false;
    }
  },

  //当前日期
  getNowDate() {
    const year = new Date()
      .getFullYear();
    const month = new Date()
      .getMonth() + 1;
    const day = new Date()
      .getDate();
    return year + '-' + month + '-' + day;
  },
  //////////////////////////////////////////////////////////////////////////////////////////
  ///
  //日期计算
  //////////////////////////////////////////////////////////////////////////////////////////
  //本月第一天
  getFirstDate() {
    let date = new Date();
    date.setDate(1);
    let month = parseInt(date.getMonth() + 1);
    let day = date.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return date.getFullYear() + '-' + month + '-' + day;
  },

  //月本最后一天
  getLastDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = new Date(year, month, 0);
    return year + '-' + month + '-' + day.getDate();
  },

  //上一月第一天
  getPreMonthFirstDate(date) {
    let arr = date.split('-');
    let year = arr[0]; //获取当前日期的年份
    let month = arr[1]; //获取当前日期的月份

    let year2 = year;
    let month2 = parseInt(month) - 1;
    if (month2 === 0) {
      //1月的上一月是前一年的12月
      year2 = parseInt(year2) - 1;
      month2 = 12;
    }

    if (month2 < 10) {
      //10月之前都需要补0
      month2 = '0' + month2;
    }
    let preMonth = year2 + '-' + month2 + '-01';
    return preMonth;
  },

  //上一月最后一天
  getPreMonthLastDate(date) {
    let arr = date.split('-');
    let year = arr[0]; //获取当前日期的年份
    let month = arr[1]; //获取当前日期的月份

    let year2 = year;
    let month2 = parseInt(month) - 1;
    if (month2 === 0) {
      //1月的上一月是前一年的12月
      year2 = parseInt(year2) - 1;
      month2 = 12;
    }

    if (month2 < 10) {
      //10月之前都需要补0
      month2 = '0' + month2;
    }
    let day = new Date(year2, month2, 0);
    let preMonth = year2 + '-' + month2 + '-' + day.getDate();
    return preMonth;
  },

  //下一月第一天
  getNextMonthFirstDate(date) {
    let arr = date.split('-');
    let year = arr[0]; //获取当前日期的年份
    let month = arr[1]; //获取当前日期的月份

    let year2 = year;
    let month2 = parseInt(month) + 1;
    if (month2 === 13) {
      //1月的上一月是前一年的12月
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }

    if (month2 < 10) {
      //10月之前都需要补0
      month2 = '0' + month2;
    }
    let NextMonth = year2 + '-' + month2 + '-01';
    return NextMonth;
  },

  //下一月最后一天
  getNextMonthLastDate(date) {
    let arr = date.split('-');
    let year = arr[0]; //获取当前日期的年份
    let month = arr[1]; //获取当前日期的月份

    let year2 = year;
    let month2 = parseInt(month) + 1;
    if (month2 === 13) {
      //1月的上一月是前一年的12月
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }

    if (month2 < 10) {
      //10月之前都需要补0
      month2 = '0' + month2;
    }
    let day = new Date(year2, month2, 0);
    let NextMonth = year2 + '-' + month2 + '-' + day.getDate();
    return NextMonth;
  },

  //今年 
  getYearFirstDate() {
    let date = new Date();
    return date.getFullYear() + '-01-01';
  },

  //今年最后一天
  getYearLastDate() {
    let date = new Date();
    return date.getFullYear() + '-12-31';
  },

  //上一年第一天 
  getPreYearFirstDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) - 1 + '-01-01';
  },

  //上一年最后一天
  getPreYearLastDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) - 1 + '-12-31';
  },

  //下一年第一天 
  getNextYearFirstDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + 1 + '-01-01';
  },

  //下一年最后一天
  getNextYearLastDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + 1 + '-12-31';
  },

  //上半年第一天 
  getPreMidYearFirstDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + '-01-01';
  },

  //上半年最后一天
  getPreMidYearLastDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + '-06-30';
  },

  //下半年第一天 
  getNextMidYearFirstDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + '-07-01';
  },

  //下半年最后一天
  getNextMidYearLastDate(date) {
    let ary = date.split('-');
    return parseInt(ary[0]) + '-12-31';
  },

  //获得两个日期相差的天数
  getDays(strDt1, strDt2) {
    const strSeparator = "-"; //日期分隔符
    let oDate1;
    let oDate2;
    let iDays;
    oDate1 = strDt1.split(strSeparator);
    oDate2 = strDt2.split(strSeparator);

    const strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
    const strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
    iDays = parseInt((strDateE - strDateS) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数 
    return iDays;
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js